'use strict';

module.exports = require('react').PropTypes;
